var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menuView"},_vm._l((_vm.menuList),function(item,index){return _c('div',{key:index,staticClass:"menu-box",class:[_vm.currentMenu.id===item.id ? 'active' : ''],on:{"click":function($event){return _vm.changeMenu(item)}}},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(item.title))]),_c('div',[_vm._v(_vm._s(item.count))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }